/**
 * Created by abdulhafeth on 2/5/17.
 */
window.WeatherAPI = new (function () {

    var self = this;
    var _protected = BaseAPI.call(self);
    var url = publicConfiguration['GatewayWeatherServer'];
    _protected.setApiUrl(url);

    self.getWeatherDetails = function (brandId, params) {
        var defer = $q.defer();
        _protected.request("brands/" + brandId , "GET", params)
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    defer.resolve(res.data.data.weather);
                } else {
                    defer.reject();
                }
            }, function (err) {
                defer.reject(err);
            });
        return defer.promise;
    };
});

WeatherAPI.FUTURE_FORECAST_DAYS_LIMIT = 13;
WeatherAPI.MAX_INTERVAL_DAYS = 60;

WeatherAPI.ICONS = {
    '113': '../images/weather-icons/113.png',
    '116': '../images/weather-icons/116.png',
    '119': '../images/weather-icons/119.png',
    '122': '../images/weather-icons/122.png',
    '143': '../images/weather-icons/143.png',
    '176': '../images/weather-icons/176.png',
    '179': '../images/weather-icons/179.png',
    '182': '../images/weather-icons/182.png',
    '185': '../images/weather-icons/185.png',
    '200': '../images/weather-icons/200.png',
    '227': '../images/weather-icons/227.png',
    '230': '../images/weather-icons/230.png',
    '248': '../images/weather-icons/248.png',
    '260': '../images/weather-icons/260.png',
    '263': '../images/weather-icons/263.png',
    '266': '../images/weather-icons/266.png',
    '281': '../images/weather-icons/281.png',
    '284': '../images/weather-icons/284.png',
    '293': '../images/weather-icons/293.png',
    '296': '../images/weather-icons/296.png',
    '299': '../images/weather-icons/299.png',
    '302': '../images/weather-icons/302.png',
    '305': '../images/weather-icons/305.png',
    '308': '../images/weather-icons/308.png',
    '311': '../images/weather-icons/311.png',
    '314': '../images/weather-icons/314.png',
    '317': '../images/weather-icons/317.png',
    '320': '../images/weather-icons/320.png',
    '323': '../images/weather-icons/323.png',
    '326': '../images/weather-icons/326.png',
    '329': '../images/weather-icons/329.png',
    '332': '../images/weather-icons/332.png',
    '335': '../images/weather-icons/335.png',
    '338': '../images/weather-icons/338.png',
    '350': '../images/weather-icons/350.png',
    '353': '../images/weather-icons/353.png',
    '356': '../images/weather-icons/356.png',
    '359': '../images/weather-icons/359.png',
    '362': '../images/weather-icons/362.png',
    '365': '../images/weather-icons/365.png',
    '368': '../images/weather-icons/368.png',
    '371': '../images/weather-icons/371.png',
    '374': '../images/weather-icons/374.png',
    '377': '../images/weather-icons/377.png',
    '386': '../images/weather-icons/386.png',
    '389': '../images/weather-icons/389.png',
    '392': '../images/weather-icons/392.png',
    '395': '../images/weather-icons/395.png'
};